import React from 'react';
import WebhooksSection from './webhooks/WebhooksSection';
import { useDeveloperSection } from './hooks/useDeveloperSection';

interface IDeveloperSectionProps {
	communityId: string;
}

const DeveloperSection: React.FC<IDeveloperSectionProps> = ({ communityId }) => {
	const { apiKeyData, loading, createAPIKey, deleteAPIKey, copyAPIKey } = useDeveloperSection(communityId);

	return (
		<section className="content">
			<div className="row">
				<div className="col-md-12">
					<div className="card card-primary">
						<div className="card-header">
							<h3 className="card-title">Developer Section (To be used for API Documentation related things)</h3>
							<div className="card-tools">
								<button type="button" className="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
									<i className="fas fa-minus"></i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<div className="col basicInfoSection mb-3 bg-white">
								<div className="basicInfoFields p-3">
									{loading && (
										<div className="d-flex justify-content-center mb-3">
											<div className="spinner-border" role="status">
												<span className="sr-only">Loading...</span>
											</div>
										</div>
									)}

									<div className="form-row">
										<div className="form-group col-md-12">
											<h4>API Key Information</h4>
											{apiKeyData?.apiKey && (
												<div className="card">
													<div className="card-body">
														<div className="row">
															<div className="col-md-12">
																<div className="input-group mt-2 text-center">
																	<strong className="mr-2">API Key:</strong>
																	<input
																		type="text"
																		className="form-control"
																		value={apiKeyData.apiKey || 'No API key found'}
																		readOnly
																	/>
																	<div className="input-group-append">
																		<button
																			className="btn btn-outline-secondary"
																			type="button"
																			onClick={copyAPIKey}
																		>
																			Copy
																		</button>
																		<button
																			className="btn btn-outline-danger"
																			type="button"
																			onClick={deleteAPIKey}
																			disabled={loading}
																		>
																			Delete
																		</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											)}
										</div>
									</div>

									{!apiKeyData?.apiKey && <div className="form-row mt-2">
										<div className="form-group col-md-12">
											<button
												type="button"
												className="btn btn-success"
												onClick={createAPIKey}
												disabled={loading}
											>
												{loading ? 'Creating...' : 'Create New API Key'}
											</button>
										</div>
									</div>}
								</div>
							</div>


							<div className="col basicInfoSection mb-3 pb-3 bg-white">
								<div className="basicInfoFields p-3">
									<WebhooksSection communityId={communityId} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default DeveloperSection;
